import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    emis: null,
    docketName: "File",
    apiUrl: "https://api.baronitsolutions.co.za",
    saveFormDataRoute: "/auth/save-form-data",
    updateFormDataRoute: "/auth/update-item",
    updateModelSingleRowRoute: "/auth/update-model-single-row",
    deleteSingleRowRoute: "/auth/delete-single-row",
    deleteMultipleRowsRoute: "/auth/delete-multiple-rows",
    retrieveAllStaffRoute: "/auth/get-all-employees",
    deleteEmployeesRoute: "/auth/delete-selected-employees",
    createSalaryRoute: "/auth/create-salary",
    createStaffRateRoute: "/auth/create-staff-rate",
    createPayrollRoute: "/auth/create-payroll",
    retrieveAllPayrollsRoute: "/auth/get-all-payrolls-for-current-year",
    addSelectedStaffToAPayrollRoute: "/auth/add-selected-employees-to-payroll",
    retrieveAllSalariesRoute: "/auth/get-all-salaries",
    applySalaryToSelectedStaffRoute: "/auth/apply-salary-to-selected-staff",
    retrieveAllRatesRoute: "/auth/get-all-rates",
    applyRateToSelectedStaffRoute: "/auth/capture-rate-now",
    retrieveAllStaffCategoriesRoute: "/auth/get-all-staff-categories",
    createStaffRoute: "/auth/create-staff",
    submitEarningsAndDeductionsRoute: "/auth/submit-earnings-and-deductions",
    saveServiceRoute: "/auth/save-service",
    foreignFieldValueRoute: "/auth/get-foreign-field-value",
    foreignKeyDataRoute: "/auth/get-foreign-key-data",
    allAgencyFeesRoute: "/auth/get-all-agency-fees",
    allClientsRoute: "/auth/get-all-clients",
    allEventsRoute: "/get-all-events",
    saveEventRoute: "/auth/save-event",
    clientInvoicesRoute: "/auth/get-client-invoices",
    logo: null,
    crudTable: null,
    socket: {},
    endPoint: "wss://express.bitsems.co.za",
    frontPageImages: [],
    bitsems: false,
    takePhotos: ["adubyte2@yahoo.com", "concordf14@gmail.com"],
    articles: [],
    postBody: "Type here ...",
    siteStats: {},
    companyLabels: localStorage.getItem("companyLabels") || {},
    pdfHTML: "Generating PDF",
    currentClient: {},
    pdfFilename: "pdf",
    globalDialogSlot: false,
    globalConfirmDelete: false,
    accessToken: localStorage.getItem("token") || "",
    authenticated: false,
    themeColor: localStorage.getItem("themeColor") || "white",
    secondaryColor: localStorage.getItem("secondaryColor") || "white",
    Loader: false,
    LoaderC: false,
    appName: localStorage.getItem("appName") || "",
    components: [],
    userCompany: { industry: null },
    userStudents: [],
    userSelectedStudentSid: null,
    currency: null,
    currentSubject: {
      name: "",
      code: "",
      topic: {},
    },
    user: { alevel: 1 },
    enableEditing: false,
    currentClientProfile: null,
    marksScheduleParams: {},
    paymentInfo: {},
    expensesCategories: [],
    serviceProviders: [],
    selectedClass: null,
    bulkSMSTokenId: "96C2A187620B41FAB3B31E0804F5EA06-01-2",
    bulkSMSTokenSecret: "mCQEABCuSZvZ106I9AKQR4hDAQjOQ",
    bulkSMSBasicAuth:
      "Authorization: Basic OTZDMkExODc2MjBCNDFGQUIzQjMxRTA4MDRGNUVBMDYtMDEtMjptQ1FFQUJDdVNadloxMDZJOUFLUVI0aERBUWpPUQ==",
    notebooks: [
      {
        name: "Notebook Lenovo Ideapad 320 Intel® Core i5-7200u 8GB",
        price: 2259,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/132381/3/132381386G1.png",
        stars: 5,
        totalReviews: 230,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Notebook Dell Inspiron i15-3567-A30P Intel Core 7ª i5 4GB",
        price: 2284,
        image:
          "https://images2.pricecheck.co.za/images/objects/hash/product/944/fca/b60/image_big_153815153.jpg?1550305722",
        stars: 3.4,
        totalReviews: 20,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Notebook Samsung Essentials E21 Intel Celeron Dual Core",
        price: 1490,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/132165/8/132165801G1.jpg",
        stars: 1,
        totalReviews: 1,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Notebook Samsung Expert X22 Intel Core 7 i5 8GB",
        price: 2307,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/132260/6/132260681G1.jpg",
        stars: 4.4,
        totalReviews: 340,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Notebook VAIO Fit 15S B1211B Intel Core i5 4GB",
        price: 2599,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/133252/7/133252789G1.jpg",
        stars: 3,
        totalReviews: 30,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Notebook Dell Alienware - i7 16GB",
        price: 14000,
        image:
          "https://images-submarino.b2w.io/produtos/01/00/sku/34470/9/34470934G1.jpg",
        stars: 2,
        totalReviews: 248,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
    ],

    smartphones: [
      {
        name: "Smartphone Xiaomi Mi A1 dual Android one 7.1",
        price: 1199,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/sku/29296/2/29296259G1.jpg",
        stars: 0,
        totalReviews: 0,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Smartphone Moto G 5S Dual Chip Android 7.0",
        price: 929,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/132474/0/132474081G1.png",
        stars: 1.5,
        totalReviews: 11,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: 'iPhone 8 Dourado 64GB Tela 4.7" IOS 11',
        price: 3949,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/132651/7/132651745G1.jpg",
        stars: 1,
        totalReviews: 2,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Smartphone Samsung Galaxy S7 Edge",
        price: 1943,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/125911/8/125911828G1.png",
        stars: 5,
        totalReviews: 310,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Smartphone Motorola Moto G6 Plus",
        price: 1699,
        image:
          "https://images-americanas.b2w.io/produtos/01/00/item/133453/1/133453185G1.jpg",
        stars: 2.9,
        totalReviews: 42,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
      {
        name: "Smartphone Motorola Moto Z3 Play",
        price: 2999,
        image:
          "https://images-submarino.b2w.io/produtos/01/00/item/133666/1/133666164G1.jpg",
        stars: 0.5,
        totalReviews: 1,
        details:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s",
      },
    ],

    cartProducts: [],
    currentProduct: {},
    showModal: false,
    showPopupCart: false,
    confirmDelete: false,
    screenWidth: null,
    placeholderImage: "/images/products/no-photo.jpg",
    userIP: localStorage.getItem("userIP") || "",
    pdfContent: JSON.parse(localStorage.getItem("pdfContent")) || null,
    docsAiLogObj: null,
    paymentDone: false,
    selectedDocKey: localStorage.getItem("docKey") || null,
    emailBodyHtml: localStorage.getItem("emailBodyHtml") || null,
    paidPlan: null,
  },
  getters: {
    getCrudTable(state) {
      if (JSON.parse(localStorage.getItem("crudTable"))) {
        state.crudTable = JSON.parse(localStorage.getItem("crudTable"));
      }
      return state.crudTable;
    },
    getPaidPlan(state) {
      return state.paidPlan;
    },
    getEmailBodyHtml(state) {
      if (localStorage.getItem("emailBodyHtml")) {
        state.emailBodyHtml = localStorage.getItem("emailBodyHtml");
      }
      return state.emailBodyHtml;
    },
    getSelectedDocKey(state) {
      if (localStorage.getItem("docKey")) {
        state.selectedDocKey = localStorage.getItem("docKey");
      }
      return state.selectedDocKey;
    },
    getDocsAiLogObj: (state) => state.docsAiLogObj,

    isCreditExpired: (state) => {
      if (!state.docsAiLogObj) return true;
      const today = new Date();
      const expiry = new Date(state.docsAiLogObj.expiry_date);
      return expiry < today;
    },

    isLimitExceeded: (state, getters) => {
      if (!state.docsAiLogObj) return true;
      return (
        getters.isCreditExpired ||
        Number(state.docsAiLogObj.credits_remaining) < 1
      );
    },

    getPaymentDone: (state, getters) => {
      if (!state.docsAiLogObj || getters.isLimitExceeded) return false;
      const today = new Date();
      const expiry = new Date(state.docsAiLogObj.expiry_date);
      return today >= expiry;
    },

    remainingDocsMessage: (state, getters) => {
      if (!state.docsAiLogObj || getters.isLimitExceeded) {
        return `You have 0 Generations Remaining.`;
      }

      const remaining = Number(state.docsAiLogObj.credits_remaining);
      const isGuest = state.docsAiLogObj.subscription === "guest";
      return `You have ${remaining} ${
        isGuest ? "Free " : ""
      }Generations Remaining.`;
    },
    getPDFContent(state) {
      if (localStorage.getItem("pdfContent")) {
        return localStorage.getItem("pdfContent");
      }
      return state.pdfContent;
    },
    getUserIP(state) {
      if (localStorage.getItem("userIP")) {
        state.userIP = localStorage.getItem("userIP");
      }
      return state.userIP;
    },
    getNotebooks: (state) => state.notebooks,
    getSmartphones: (state) => state.smartphones,
    getAllProducts: (state) => state.notebooks.concat(state.smartphones),
    getProductsInCart: (state) => state.cartProducts,
    getCurrentProduct: (state) => state.currentProduct,
    getShowModal: (state) => state.showModal,
    getPopupCart: (state) => state.showPopupCart,
    getScreenWidth(state) {
      return state.screenWidth;
    },
    getSaveFormDataRoute(state) {
      return state.saveFormDataRoute;
    },
    getUpdateFormDataRoute(state) {
      return state.updateFormDataRoute;
    },
    getUpdateModelSingleRowRoute(state) {
      return state.updateModelSingleRowRoute;
    },
    getDeleteSingleRowRoute(state) {
      return state.deleteSingleRowRoute;
    },
    getDeleteMultipleRowsRoute(state) {
      return state.deleteMultipleRowsRoute;
    },
    getAllStaffRoute(state) {
      return state.retrieveAllStaffRoute;
    },
    getDeleteEmployeesRoute(state) {
      return state.deleteEmployeesRoute;
    },
    getCreateSalaryRoute(state) {
      return state.createSalaryRoute;
    },
    getCreateStaffRateRoute(state) {
      return state.createStaffRateRoute;
    },
    getCreatePayrollRoute(state) {
      return state.createPayrollRoute;
    },
    getRetrieveAllPayrollsRoute(state) {
      return state.retrieveAllPayrollsRoute;
    },
    getAddSelectedStaffToAPayrollRoute(state) {
      return state.addSelectedStaffToAPayrollRoute;
    },
    getRetrieveAllSalaries(state) {
      return state.retrieveAllSalariesRoute;
    },
    getCompanyEmis(state) {
      return state.emis;
    },
    getApplySalaryToSelectedStaffRoute(state) {
      return state.applySalaryToSelectedStaffRoute;
    },
    getRetrieveAllRatesRoute(state) {
      return state.retrieveAllRatesRoute;
    },
    getApplyRateToSelectedStaffRoute(state) {
      return state.applyRateToSelectedStaffRoute;
    },
    getRetrieveAllStaffCategoriesRoute(state) {
      return state.retrieveAllStaffCategoriesRoute;
    },
    getCreateStaffRoute(state) {
      return state.createStaffRoute;
    },
    getSubmitEarningsAndDeductionsRoute(state) {
      return state.submitEarningsAndDeductionsRoute;
    },
    getSaveServiceRoute(state) {
      return state.saveServiceRoute;
    },
    getForeignFieldValueRoute(state) {
      return state.foreignFieldValueRoute;
    },
    getForeignKeyDataRoute(state) {
      return state.foreignKeyDataRoute;
    },
    getAllAgencyFeesRoute(state) {
      return state.allAgencyFeesRoute;
    },
    getAllClientsRoute(state) {
      return state.allClientsRoute;
    },
    getAllEventsRoute(state) {
      return state.allEventsRoute;
    },
    getSaveEventRoute(state) {
      return state.saveEventRoute;
    },
    getClientInvoicesRoute(state) {
      return state.clientInvoicesRoute;
    },
    getLogo(state) {
      if (localStorage.getItem("logo") != null) {
        state.logo = localStorage.getItem("logo");
      }
      return state.logo;
    },
    isMobile(state, getters) {
      return getters.getScreenWidth && getters.getScreenWidth < 600;
    },
    getConfirmDelete(state) {
      return state.confirmDelete;
    },
    isGeneral(state) {
      return state.userCompany.industry == "General";
    },
    isLegalPractice(state) {
      return state.userCompany.industry == "Legal Practice";
    },
    getDocketName(state) {
      return state.docketName;
    },
    getThemeStyle(state) {
      return {
        "background-color": state.themeColor,
        color: state.secondaryColor,
      };
    },
    getPlaceholderImage(state) {
      return state.placeholderImage;
    },
    getOutlineColor(state) {
      return state.secondaryColor == "#ffffff"
        ? state.themeColor
        : state.secondaryColor;
    },
    getExpensesCategories(state) {
      return state.expensesCategories;
    },
    getServiceProviders(state) {
      return state.serviceProviders;
    },
    getBulkSMSTokenId(state) {
      return state.bulkSMSTokenId;
    },
    getBulkSMSTokenSecret(state) {
      return state.bulkSMSTokenSecret;
    },
    getBulkSMSBasicAuth(state) {
      return state.bulkSMSBasicAuth;
    },
    getSocket(state) {
      return state.socket;
    },
    getEndPoint(state) {
      return state.endPoint;
    },
    getTakePhotos(state) {
      return state.takePhotos;
    },
    getFrontPageImages(state) {
      return state.frontPageImages;
    },
    itsBitsems(state) {
      return state.bitsems;
    },
    isManager(state) {
      return state.user.alevel >= 9;
    },
    isAdmin(state) {
      return state.user.alevel >= 7;
    },
    isStaff(state) {
      return state.user.alevel >= 5;
    },
    isParentOrStudent(state) {
      return state.user.alevel == 3;
    },
    isGuest(state) {
      return state.user.alevel == 1;
    },
    isEverybody() {
      return true;
    },
    isEverybodyEA(state) {
      return state.user.alevel < 6;
    },
    getApiUrl(state) {
      return state.apiUrl;
    },
    getArticles(state) {
      return state.articles;
    },
    getSiteStats(state) {
      return state.siteStats;
    },
    enableEditing(state) {
      return state.enableEditing;
    },
    getGlobalDialogSlot(state) {
      return state.globalDialogSlot;
    },
    getGlobalConfirmDelete(state) {
      return state.globalConfirmDelete;
    },
    getPdfFilename(state) {
      return state.pdfFilename;
    },
    getAuthenticated(state){
      if(JSON.parse(localStorage.getItem('authenticated'))){
        state.authenticated = JSON.parse(localStorage.getItem('authenticated'))
      }
      return state.authenticated
    },
    getComponents(state) {
      return state.components;
    },
    getCurrency(state) {
      if (localStorage.getItem("currency") != null) {
        state.currency = localStorage.getItem("currency");
      }
      return state.currency;
    },
    getAppName(state) {
      if (localStorage.getItem("appName") != null) {
        state.appName = localStorage.getItem("appName");
      }
      return state.appName;
    },
    getUserCompany(state) {
      if (JSON.parse(localStorage.getItem("userCompany")) != null) {
        state.userCompany = JSON.parse(localStorage.getItem("userCompany"));
      }
      return state.userCompany;
    },
    getCompanyLabels(state) {
      if (JSON.parse(localStorage.getItem("companyLabels")) != null) {
        state.companyLabels = JSON.parse(localStorage.getItem("companyLabels"));
      }
      return state.companyLabels;
    },
    getCurrentUser(state) {
      if (JSON.parse(localStorage.getItem("currentUser"))) {
        state.user = JSON.parse(localStorage.getItem("currentUser"));
      }
      return state.user;
    },
    getCurrentClient(state) {
      return state.currentClient;
    },
    getCurrentClientProfile(state) {
      return state.currentClientProfile;
    },
    getThemeColor(state) {
      if (localStorage.getItem("themeColor")) {
        state.themeColor = localStorage.getItem("themeColor");
      }
      return state.themeColor;
    },
    getSecondaryColor(state) {
      if (localStorage.getItem("secondaryColor")) {
        state.secondaryColor = localStorage.getItem("secondaryColor");
      }
      return state.secondaryColor;
    },
    getLoader(state) {
      return state.Loader;
    },
    getAccessToken(state) {
      if (localStorage.getItem("token") != null) {
        state.accessToken = localStorage.getItem("token");
      }
      return state.accessToken;
    },
    getPaymentInfo(state) {
      return state.paymentInfo;
    },
    getPostBody(state) {
      return state.postBody;
    },
  },
  mutations: {
    setCrudTable(state, tableObj) {
      localStorage.setItem("crudTable", JSON.stringify(tableObj));
      return state.crudTable;
    },
    setPaidPlan(state, paidPlan) {
      state.paidPlan = paidPlan;
    },
    setEmailBodyHtml(state, payload) {
      state.emailBodyHtml = payload;
      localStorage.setItem("emailBodyHtml", payload);
    },
    setSelectedDocKey(state, docKey) {
      state.selectedDocKey = docKey;
      localStorage.setItem("docKey", docKey);
    },
    setDocsAiLogObj(state, docsAiLogObj) {
      state.docsAiLogObj = docsAiLogObj;
    },

    setPaymentDone(state, payload) {
      state.paymentDone = payload;
    },
    setPDFContent(state, pdfContent) {
      state.pdfContent = pdfContent;
      localStorage.setItem("pdfContent", pdfContent);
    },
    setUserIP(state, ip) {
      state.userIP = ip;
      localStorage.setItem("userIP", ip);
    },
    setLogo(state, logoPath) {
      state.logo = logoPath;
    },
    setScreenWidth(state, screenWidth) {
      state.screenWidth = screenWidth;
    },
    setConfirmDelete(state, payload) {
      state.confirmDelete = payload;
    },
    setGlobalDialogSlot(state, payload) {
      state.globalDialogSlot = payload;
    },
    setGlobalConfirmDelete(state, payload) {
      state.globalConfirmDelete = payload;
    },
    setSocket(state, socket) {
      state.socket = socket;
    },
    setBitsems(state, boolVal) {
      state.bitsems = boolVal;
    },
    setFrontPageImages(state, frontPageImages) {
      state.frontPageImages = frontPageImages;
    },
    setSiteArticles(state, articles) {
      state.articles = articles;
    },
    setSiteStats(state, stats) {
      state.siteStats = stats;
    },
    enableEditing(state, payload) {
      state.enableEditing = payload;
    },
    setThemeColor(state, color) {
      state.themeColor = color;
    },
    setSecondaryColor(state, color) {
      state.secondaryColor = color;
    },
    setAppName(state, appName) {
      state.appName = appName;
    },
    setUserCompany(state, company) {
      state.userCompany = company;
    },
    setCurrency(state, currency) {
      state.currency = currency;
    },
    setCompanyLabels(state, labels) {
      state.companyLabels = labels;
    },
    setAuthenticated(state, payload){
      state.authenticated = payload
      localStorage.setItem("authenticated",JSON.stringify(payload))
    },
    setAccessToken(state, payload) {
      state.accessToken = payload;
      localStorage.setItem("token", payload);
    },
    setCompanyEmis(state, payload) {
      state.emis = payload;
    },
    setCurrentUser(state, payload) {
      state.user = payload;
      localStorage.setItem("currentUser", JSON.stringify(payload));
    },
    setCurrentClient(state, client) {
      state.currentClient = client;
    },
    setCurrentClientProfile(state, clientProfile) {
      state.currentClientProfile = clientProfile;
    },
    setLoader(state, payload) {
      state.Loader = payload;
    },
    setCounterLoader(state, payload) {
      state.LoaderC = payload;
    },
    setCounterLoader(state, payload) {
      state.LoaderC = payload;
    },

    pushToComponents(state, payload) {
      state.components = payload;
    },
    initializeComponents(state, payload) {
      state.components = payload;
    },
    setPaymentInfo(state, paymentInfo) {
      state.paymentInfo = paymentInfo;
    },
    setExpensesCategories(state, categories) {
      state.expensesCategories = categories;
    },
    setServiceProviders(state, serviceProviders) {
      state.serviceProviders = serviceProviders;
    },
    sliceComponent(state, index) {
      state.components = state.components.filter((element, i) => {
        return i != index;
      });
    },
    updateStoreComponent(state, { index, componentSection, imgData }) {
      let obj = { content: null, arrayIndex: null, imgData: null };
      obj = state.components[index];
      obj.content = componentSection;
      obj.arrayIndex = index;
      obj.imgData = imgData;
    },
    setPostBody(state, postBody) {
      state.postBody = postBody;
    },
    ADD_PRODUCT: (state, product) => {
      state.cartProducts.push(product);
    },
    REMOVE_PRODUCT: (state, index) => {
      state.cartProducts.splice(index, 1);
    },
    CURRENT_PRODUCT: (state, product) => {
      state.currentProduct = product;
    },
    SHOW_MODAL: (state) => {
      state.showModal = !state.showModal;
    },
    SHOW_POPUP_CART: (state) => {
      state.showPopupCart = !state.showPopupCart;
    },
  },
  actions: {
    addProduct: (context, product) => {
      context.commit("ADD_PRODUCT", product);
    },
    removeProduct: (context, index) => {
      context.commit("REMOVE_PRODUCT", index);
    },
    currentProduct: (context, product) => {
      context.commit("CURRENT_PRODUCT", product);
    },
    showOrHiddenModal: (context) => {
      context.commit("SHOW_MODAL");
    },
    showOrHiddenPopupCart: (context) => {
      context.commit("SHOW_POPUP_CART");
    },
  },
  modules: {},
});
